'use strict';
define([
  "dojo/_base/declare",
  "mw-filebrowser/actions/Action",
  "dojo/i18n!nls/mldoStringResource",
], function (declare, Action, MLDOStrings) {
  return declare(Action, {
    constructor: function (args) {
      args = args || {};
      var context = args.context;
      var makeActionAvailable = args.showAction || false;
      this.name =  MLDOStrings.previewPageAddLabel;
      this.getInvitationDetailsMethod = args.getInvitationDetailsMethod;
      this.enabled = makeActionAvailable;
      this.label = MLDOStrings.previewPageAddLabel;
      this.section = {
        id: "MISC",
        name: "MISC",
        allowSubMenu: true,
        forceSubMenu: false
      };
      this.id = "mldoAddToDriveAction";
      this.allowSubMenu = true;
      this.childActionIds =["addShortcutAction", "copyToDriveAction"];
      this.isApplicableTo = function () {
        let invitationStatus;
        if (this.getInvitationDetailsMethod && typeof this.getInvitationDetailsMethod === "function" && this.getInvitationDetailsMethod()) {
          invitationStatus = this.getInvitationDetailsMethod().invitationStatus;
        }
        if (invitationStatus === "ACCEPTED") {
          this.enabled = false;
        } else {
          this.enabled =  makeActionAvailable && true;
        }
        return this.enabled;
      };
    }
  });

});